export const orgsApi = (client) => ({
    getCurrent: () => client.get('/api/v1/org').then((r) => r.data),
    getStatus: () => client.get('/api/v1/org/status').then((r) => r.data),
    update: (body) => client.patch('/api/v1/org', body).then((r) => r.data),
    remove: () => client.delete('/api/v1/org').then((r) => r.data),
    uploadQrLogo: (file) => {
        const form = new FormData();
        form.append('file', file);
        return client.post('/api/v1/org/qr-logo', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }).then((r) => r.data);
    },
});
//# sourceMappingURL=orgs.js.map